import { observable, action, runInAction, computed } from "mobx";
import moment from 'moment';
import PisoSalarialService from "../../../services/PisoSalarialService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import ParametroGeralService from "../../../services/ParametroGeralService";
export default class PisoSalarialStore {

    @observable pisosList = [];
    @observable pisoSelecionado = {};
    @observable loading = false;
    @observable impactedCount = 0;
    @observable empresasGlobo = [];
    @observable sindicatos = [];
    @observable parametros;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.pisoSalarialService = new PisoSalarialService();
        this.empresaGloboService = new EmpresaGloboService();
        this.parametroGeralService = new ParametroGeralService();
        this.obterParametrosGerais();
        this.resetPisoSelecionado();

    }

    @computed
    get dataVigencia(){
        return this.pisoSelecionado.momentDataInicioVigencia;
    }

    obterParametrosGerais = async () => {

        if (this.parametros) {
            return this.parametros;
        }

        const response = await this.parametroGeralService.list();

        runInAction(() => {
            this.parametros = response.data;
        });

        return response.data;

    }

    calcularEConfigurarDataVigencia = (parametros) => {
        const diaGerControlePonto = parametros ? parametros.pgmDiaGerControlePonto : 16;
        const hoje = moment();
        let dataVigencia = moment().date(diaGerControlePonto).startOf('day');
        if (hoje.date() < diaGerControlePonto) {
            dataVigencia.subtract(1, 'month');
        }
        this.pisoSelecionado.momentDataInicioVigencia = dataVigencia;
        this.pisoSelecionado.dataInicioVigencia = dataVigencia.toISOString();
    }

    @action
    resetPisoSelecionado = () => {
        this.pisoSelecionado = {
            id: null,
            sindicato: {},
            empresaGlobo: {},
            valor: null,
            dataInicioVigencia: null,
            momentDataInicioVigencia: null,
            aplicarReajuste: false
        };
        this.impactedCount = 0;
    }

    @action
    setSindicatoId = (value) => {
        this.pisoSelecionado.sindicato.id = value;
    }

    @action
    setEmpresaGloboId = (value) => {
        this.pisoSelecionado.empresaGlobo.id = value;
        //this.fetchImpactedCount();
    }

    @action
    setValor = (value) => {
        this.pisoSelecionado.valor = value;
    }

    @action
    toggleAplicarReajuste() {
        this.pisoSelecionado.aplicarReajuste = !this.pisoSelecionado.aplicarReajuste;
    }

    @action
    carregarLista = () => {
        this.loading = true;
        this.pisoSalarialService.list()
            .then(action(response => {
                this.pisosList = response.data;
                this.loading = false;
            }))
            .catch(action(error => {
                console.error(error);
                this.loading = false;
            }));
    }

    @action
    preencherModal = (row) => {
        if (row) {
            this.pisoSelecionado.id = row.id;
            this.pisoSelecionado.sindicato = row.sindicato;
            this.pisoSelecionado.empresaGlobo = row.empresaGlobo;
            this.pisoSelecionado.valor = row.valor;
            this.pisoSelecionado.momentDataInicioVigencia = moment(row.dataInicioVigencia).startOf('day');
            this.pisoSelecionado.dataInicioVigencia = this.pisoSelecionado.momentDataInicioVigencia.toISOString();
            this.pisoSelecionado.aplicarReajuste = row.aplicarReajuste;
        } else {
            this.resetPisoSelecionado();
            this.calcularEConfigurarDataVigencia(this.parametros);
        }
    }

    @action
    cadastrar = () => {
        return this.pisoSalarialService.save(this.pisoSelecionado).then(response => {
            this.pisosList.push(response.data);
            this.carregarLista();
        });
    }

    @action
    editar = () => {
        let tabelaIndex = this.pisosList.findIndex((tabelaItem) => tabelaItem.id === this.pisoSelecionado.id);
        return this.pisoSalarialService.edit(this.pisoSelecionado.id, this.pisoSelecionado).then(response => {
            this.pisosList[tabelaIndex] = response.data;
            this.carregarLista();
        });
    }

    @action    
    remover = () => {
        let tabelaIndex = this.pisosList.findIndex((tabelaItem) => tabelaItem.id === this.pisoSelecionado.id);
        let modal = this.modalStore;

        return this.pisoSalarialService.delete(this.pisoSelecionado.id).then(response => {
            this.pisosList.splice(tabelaIndex, 1);
            modal.toggleModal()
            //this.carregarLista();
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        });
    }

    @action
    fetchImpactedCount = () => {
        const { sindicatoId, empresaGloboId, valor } = this.pisoSelecionado;
        if (sindicatoId && empresaGloboId && valor > 0) {
            const params = { sindicatoId, empresaId: empresaGloboId, valor };
            this.pisoSalarialService.contarContratosImpactados(params)
                .then(action(response => {
                    this.impactedCount = response.data;
                }))
                .catch(action(error => {
                    console.error(error);
                    this.impactedCount = 0;
                }));
        } else {
            this.impactedCount = 0;
        }
    }

    @action
    carregarEmpresasGlobo = () => {
        return this.empresaGloboService.list().then(action(response => {
            this.empresasGlobo = response.data.filter(e => e.ativo);
        }));
    }

    @action
    carregarSindicatos = () => {
        return this.pisoSalarialService.listarSindicatos().then(action(response => {
            this.sindicatos = response.data;
        }));
    }
    
    setLista = (value) => {
        this.pisosList = value;
    }
    
}
